import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import QbetaLogo from '../Qbeta-Logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/academy') {
      return location.pathname === '/academy';
    }
    return location.pathname.startsWith(path);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  // Close any open dropdown when the route changes
  useEffect(() => {
    setActiveDropdown(null);
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className="navbar">
      <div className="top-marquee" aria-hidden={false}>
        <div className="marquee-inner">
          <div className="marquee-left">
            <a href="tel:+919876543210">+91 98765 43210</a>
            <a href="tel:+918765432109">+91 87654 32109</a>
            <a href="mailto:info@qbeta.com">info@qbeta.com</a>
          </div>
          <div className="marquee-right" aria-label="social links">
            <a className="social linkedin" href="https://linkedin.com/company/qbeta-academy" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM0 8h5v14H0V8zm7.5 0h4.8v2h.1c.67-1.2 2.3-2.4 4.7-2.4 5 0 5.9 3.3 5.9 7.6V22H17v-6.3c0-1.5 0-3.4-2.1-3.4-2.1 0-2.4 1.6-2.4 3.3V22H7.5V8z" />
              </svg>
            </a>

            <a className="social instagram" href="https://instagram.com/qbeta_academy" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.3 2.4.5.6.2 1 .5 1.4 1 .4.4.8.9 1 1.4.2.5.4 1.2.5 2.4.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.3 1.9-.5 2.4-.2.6-.5 1-1 1.4-.4.4-.9.8-1.4 1-.5.2-1.2.4-2.4.5-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.3-2.4-.5-.6-.2-1-.5-1.4-1-.4-.4-.8-.9-1-1.4-.2-.5-.4-1.2-.5-2.4C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.3-1.9.5-2.4.2-.6.5-1 1-1.4.4-.4.9-.8 1.4-1 .5-.2 1.2-.4 2.4-.5C8.4 2.2 8.8 2.2 12 2.2zm0 3.1a6.7 6.7 0 100 13.4A6.7 6.7 0 0012 5.3zm0 10.9a4.2 4.2 0 110-8.4 4.2 4.2 0 010 8.4zm6.6-11.9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"/>
              </svg>
            </a>

            <a className="social youtube" href="https://youtube.com/@qbeta-academy" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M23.5 6.2s-.2-1.6-.8-2.3c-.8-.9-1.7-.9-2.1-1C16.8 2 12 2 12 2s-4.8 0-8.6.9c-.4.1-1.3.1-2.1 1C.2 4.6 0 6.2 0 6.2S-.1 8-.1 9.8v.4C0 12.1 0 14 0 14s.2 1.6.8 2.4c.8.9 1.9.9 2.4 1 1.8.3 7.3.8 8.8.8s4.8-.1 8.6-.9c.4-.1 1.3-.1 2.1-1 .6-.8.8-2.4.8-2.4s.1-1.9.1-3.7v-.4c0-1.8-.1-3.6-.1-3.6zM9.6 15.5V8.5l6.4 3.5-6.4 3.5z"/>
              </svg>
            </a>

            <a className="social facebook" href="https://facebook.com/qbetaacademy" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M22 12.1C22 6.5 17.5 2 11.9 2S2 6.5 2 12.1C2 17 5.7 21 10.5 21v-6.6H8.2V12h2.3V9.8c0-2.3 1.4-3.6 3.5-3.6 1 0 1.9.1 2.1.1v2.4h-1.2c-1 0-1.3.6-1.3 1.2V12h2.5l-.4 2.4h-2.1V21C18.3 21 22 17 22 12.1z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="navbar-container">
        <Link to="/academy" className="navbar-logo">
          <span className="logo-wrap">
            <img src={QbetaLogo} alt="EduTech" className="site-logo" />
          </span>
        </Link>
        
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/academy" className={isActive('/academy') && location.pathname === '/academy' ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Home</Link></li>
          
          <li className="dropdown">
            <span 
              className={location.pathname.includes('course') ? 'active' : ''}
              onClick={() => toggleDropdown('programs')}
            >
              Programs
            </span>
            <ul className={`dropdown-menu ${activeDropdown === 'programs' ? 'active' : ''}`}>
              <li>
                <Link to="/academy/data-analytics-course" className={isActive('/academy/data-analytics-course') ? 'active' : ''} onClick={() => { setIsMenuOpen(false); setActiveDropdown(null); }}>
                  Data Analytics
                </Link>
              </li>
              <li>
                <Link to="/academy/data-engineering-course" className={isActive('/academy/data-engineering-course') ? 'active' : ''} onClick={() => { setIsMenuOpen(false); setActiveDropdown(null); }}>
                  Data Engineering
                </Link>
              </li>
              <li>
                <Link to="/academy/data-science-ai-course" className={isActive('/academy/data-science-ai-course') ? 'active' : ''} onClick={() => { setIsMenuOpen(false); setActiveDropdown(null); }}>
                  Data Science with AI
                </Link>
              </li>
            </ul>
          </li>
          
          <li><Link to="/academy/why-us" className={isActive('/academy/why-us') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Why Us</Link></li>
          <li><Link to="/academy/blog" className={isActive('/academy/blog') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Blog</Link></li>
          <li><Link to="/academy/about" className={isActive('/academy/about') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>About</Link></li>
          <li><Link to="/academy/contact" className={isActive('/academy/contact') ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>Contact</Link></li>
          
          <li>
            <Link to="/academy/apply" className="btn-cta" onClick={() => setIsMenuOpen(false)}>
              Talk to Career Expert
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
